import Vue from 'vue/dist/vue.esm.js'
import VCalendar from 'v-calendar';
Vue.use(VCalendar);

if(document.querySelector('#samplecalendar')) {
  new Vue({
    el: '#samplecalendar',
    data() {
      return {
        dates: [
          {
            date: new Date(),
          },
        ],
        selected: {},
      };
    },
    methods: {
      addDate() {
        this.dates.push({
          date: new Date(),
        });
        this.$nextTick(() => {
          const btn = this.$refs.button[this.$refs.button.length - 1];
          btn.click();
        });
      },
      removeDate(date, hide) {
        this.dates = this.dates.filter((d) => d !== date);
        hide();
      },
      dateSelected(e, date, toggle) {
        this.selected = date;
        toggle({ ref: e.target });
      },
    },
  })
}